// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
    display: flex;
}

.message__answer {
    justify-content: flex-start;
    margin: 10px 0 10px 20px;
}

.message__question {
    justify-content: flex-end;
    margin: 10px 20px 10px 10px;
}

.message__content {
    max-width: 80%;
    width: auto;
    background-color: #eceff1;
    border-radius: 4px;
    border: 1px solid rgba(1, 1, 1, 0.2);
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 
                0px 1px 1px 0px rgba(0,0,0,0.14),
                0px 1px 3px 0px rgba(0,0,0,0.12);
    overflow-wrap: break-word;
}

.message__question .message__content {
    text-align: right;
    padding: 5px 5px 5px 5px;
    background-color: white;
}

.message__answer .message__content {
    padding: 5px 5px 5px 5px;
    background-color: #eceff1;
}

.message__answer .message__content tbody td {
    vertical-align: middle;
}

.message__content .message__created-date {
    color: #78909c;
    font-size: 0.75rem;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-widget/message/Message.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC;;gDAE4C;IAC5C,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".message {\r\n    display: flex;\r\n}\r\n\r\n.message__answer {\r\n    justify-content: flex-start;\r\n    margin: 10px 0 10px 20px;\r\n}\r\n\r\n.message__question {\r\n    justify-content: flex-end;\r\n    margin: 10px 20px 10px 10px;\r\n}\r\n\r\n.message__content {\r\n    max-width: 80%;\r\n    width: auto;\r\n    background-color: #eceff1;\r\n    border-radius: 4px;\r\n    border: 1px solid rgba(1, 1, 1, 0.2);\r\n    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), \r\n                0px 1px 1px 0px rgba(0,0,0,0.14),\r\n                0px 1px 3px 0px rgba(0,0,0,0.12);\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.message__question .message__content {\r\n    text-align: right;\r\n    padding: 5px 5px 5px 5px;\r\n    background-color: white;\r\n}\r\n\r\n.message__answer .message__content {\r\n    padding: 5px 5px 5px 5px;\r\n    background-color: #eceff1;\r\n}\r\n\r\n.message__answer .message__content tbody td {\r\n    vertical-align: middle;\r\n}\r\n\r\n.message__content .message__created-date {\r\n    color: #78909c;\r\n    font-size: 0.75rem;\r\n    font-style: italic;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
